











































































































import { Component, Vue } from 'vue-property-decorator';
import RoleForm from '@/views/system/role-form.vue';
import RoleBindMenus from '@/views/system/role-bind-menus.vue';
import RoleBindPermissions from '@/views/system/role-bind-permissions.vue';
import { deleteRole, getRolePage, publishedRole } from '@/api/system/RoleApi';
import { RoleData, RoleModel } from '@/models/system/RoleModel';

@Component({
  name: 'RoleList',
  components: {
    RoleForm,
    RoleBindPermissions,
    RoleBindMenus
  }
})
export default class RoleList extends Vue {
  // 表单搜索Model
  searchForm: any = { name: '' };
  // 列表加载状态
  tableLoading: boolean = false;
  // 角色列表
  roleList: RoleModel[] = [];
  // 当前选中角色
  currentRole: RoleModel = RoleData;
  // 角色id
  roleId: string = '';

  // 是否显示新增/编辑角色弹窗
  roleFormDiglogVisible: boolean = false;
  // 是否显示角色绑定菜单弹窗
  roleBindMenusDiglogVisible: boolean = false;
  // 是否显示角色绑定权限弹窗
  roleBindPermissionsDiglogVisible: boolean = false;

  // 分页参数
  pageIndex: number = 1;
  // 每页大小
  pageSize: number = 10;
  // 总条数
  total: number = 0;
  // 当前页
  currentPage: number = 1;

  /**
   * onMounted
   */
  mounted() {
    // 获取角色列表
    this.getRoleList();
  }

  /**
   * 搜索
   */
  handleSearch() {
    this.pageIndex = 1;
    this.getRoleList();
  }

  /**
   * 重置搜索
   */
  resetSearch() {
    // 置空搜索表单
    this.pageIndex = 1;
    this.searchForm = { name: '' };
    this.getRoleList();
  }

  /**
   * 获取角色列表
   */
  getRoleList() {
    let params = {
      name: this.searchForm.name,
      page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
    };
    this.tableLoading = true;
    getRolePage(params)
      .then((res: Record<any, any>) => {
        if (res.code == '1' && res.data) {
          this.roleList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      })
      .finally(() => {
        this.tableLoading = false;
      });
  }

  /**
   * 改变分页大小
   */
  changePageSize(pageSize: number) {
    if (pageSize < 1) {
      this.pageSize = 1;
    } else if (pageSize >= this.total) {
      this.pageSize = this.total;
    } else {
      this.pageSize = pageSize;
    }
    this.getRoleList();
  }

  /**
   * 跳转至某页
   */
  changePage(page: number) {
    let totalPage = this.total / this.pageSize;
    let remainder = this.total % this.pageSize;
    if (remainder != 0) {
      totalPage++;
    }

    if (page < 1) {
      this.pageIndex = 1;
    } else if (page > totalPage) {
      this.pageIndex = totalPage;
    } else {
      this.pageIndex = page;
    }
    this.getRoleList();
  }

  /**
   * 打开角色编辑弹窗
   */
  openRoleForm(row?: any) {
    if (row) {
      this.currentRole = row;
      this.roleId = row.id;
    }
    this.roleFormDiglogVisible = true;
  }

  /**
   * 打开角色绑定菜单弹窗
   */
  openRoleBindMenus(row?: any) {
    if (row) {
      this.currentRole = row;
      this.roleId = row.id;
      this.roleBindMenusDiglogVisible = true;
    }
  }

  /**
   * 打开角色绑定权限弹窗
   */
  openRoleBindPermissions(row?: any) {
    if (row) {
      this.currentRole = row;
      this.roleId = row.id;
      this.roleBindPermissionsDiglogVisible = true;
    }
  }

  /**
   * 发布角色
   * @param row
   */
  publishRole(row?: any) {
    if (row) {
      this.currentRole = row;
      let rid = row.id;
      this.$confirm(this.$t('lang_are_you_sure_to_release_it') as string, this.$t('lang_tips') as string, {
        confirmButtonText: this.$t('lang_determine_') as string,
        cancelButtonText: this.$t('lang_cancel_') as string,
        type: 'warning'
      })
        .then(() => {
          publishedRole(rid)
            .then((res: Record<any, any>) => {
              if (res.code == '1') {
                this.$message.success(res.message);
                this.getRoleList();
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发布'
          });
        });
    }
  }

  /**
   * 删除角色
   * @param row
   */
  deleteRoleByRoleId(row?: any) {
    if (row) {
      this.currentRole = row;
      let rid = row.id;
      this.$confirm(this.$t('lang_whether_or_not_to_delete') as string, this.$t('lang_tips') as string, {
        confirmButtonText: this.$t('lang_determine_') as string,
        cancelButtonText: this.$t('lang_cancel_') as string,
        type: 'warning'
      })
        .then(() => {
          deleteRole(rid)
            .then((res: Record<any, any>) => {
              if (res.code == '1') {
                this.$message.success(res.message);
                this.getRoleList();
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('lang_undeleted') as string
          });
        });
    }
  }
}
